import React from "react";
import { Select } from "antd";
import { useActivityTopicsLookup } from "../../../custom-hooks/common/queries";

interface IAddActivityProp {
    search: string;
    onSearch: (a: any) => void;
    [key: string]: any;
}

const AddActivityLookup: React.FC<IAddActivityProp> = ({ search, onSearch, ...props }) => {
    const { data: activityTopics = [], isLoading: activityTopicLoading } = useActivityTopicsLookup({
        searchText: search
    });

    return (
        <Select
            {...props}
            onSearch={onSearch}
            mode="multiple"
            loading={activityTopicLoading}
            showSearch
            allowClear
            filterOption={false} // added this line in order to render updated data
        >
            {activityTopics?.map((data: { value: number; label: string }) => {
                return (
                    <Select.Option key={data.value} value={data.value}>
                        {data.label}
                    </Select.Option>
                );
            })}
        </Select>
    );
};
export default AddActivityLookup;
